import { getCurrentDomain, isLocalhost } from "./domain";
export function serviceUrl(service, path) {
    const currentDomain = getCurrentDomain(window.location);
    const basePath = service
        ? `https://${service}.${currentDomain}`
        : `https://${currentDomain}`;
    if (path) {
        return `${basePath}/${path}`;
    }
    return basePath;
}
export function betterServiceUrl(service, path) {
    const currentDomain = getCurrentDomain(window.location);
    let basePath = service
        ? `//${service}.${currentDomain}`
        : `//${currentDomain}`;
    if (isLocalhost(window.location)) {
        basePath = `//${currentDomain}`;
    }
    if (path) {
        return `${basePath}/${path}`;
    }
    return basePath;
}
//# sourceMappingURL=serviceurl.js.map